<template lang="pug">
  div
    p.label.space Dados do imóvel
    el-row.marginBotton(type='flex', :gutter="30")
      el-col(:span="8" v-if="isOnerosoNaoOneroso")
        validation-provider(rules="required", v-slot="{ errors }")
          app-label(label="Gleba do Imóvel:" :required="true")
          el-input.input(
            v-model="dadosImovel.gleba"
            name="Gleba"
            :class="{'erro' : errors.length}"
          )
          span.help.erro {{ errors[0] }}
      el-col(:span="8")
        validation-provider(:rules="isOnerosoNaoOneroso ? 'required': ''", v-slot="{ errors }")
          app-label(label="Bairro/Povoado:" :required="isOnerosoNaoOneroso")
          el-input.input(
            v-model="dadosImovel.povoado"
            name="Povoado"
            :class="{'erro' : errors.length}"
          )
          span.help.erro {{ errors[0] }}

      el-col(:span="8" v-if="isReurbIndividual")
        app-label(label="Logradouro do Imóvel:" :required="false")
        el-input.input(
          v-model="dadosImovel.logradouro"
          name="Povoado"
        )
      el-col(:span="8")
        validation-provider(:rules="isOnerosoNaoOneroso ? 'required': ''", v-slot="{ errors }")
            app-label(label="Município do Imóvel:" :required="isOnerosoNaoOneroso")
            el-select.full-width.input(
              v-model='dadosImovel.municipio'
              filterable
              :class="{'erro' : errors.length}"
            )
              el-option(
                  v-for='municipio in municipios'
                  :key='municipio.id',
                  :label='municipio.nome'
                  :value='municipio.id'
              )
            span.help.erro {{ errors[0] }}
    el-row.marginBotton(type='flex', :gutter="30", v-if="isReurbIndividual")
      el-col(:span="8")
        validation-provider(rules="required", v-slot="{ errors }")
          app-label(label="Número de controle:")
          el-input.input(
            v-model="dadosImovel.numeroDeControle"
            name="numeroDeControle"
            :class="{'erro' : errors.length}"
          )
      el-col(:span="8")
        validation-provider(rules="required", v-slot="{ errors }")
          app-label(label="Quadra de controle:")
          el-input.input(
            v-model="dadosImovel.quadraDeControle"
            name="quadraDeControle"
            :class="{'erro' : errors.length}"
          )
      el-col(:span="8")
        div.inputArea
          div
            app-label(label="Área:" :required="false")
            app-double-input.input(
              v-model="dadosImovel.areaOrigin",
              name='Área',
              :precision="4",
              :onkeypress="onlyInputNumbers",
              :showAppend ="false",
            )
            p.conversao(v-if="dadosImovel.areaOrigin && dadosImovel.tipoArea") Conversão: {{ conversaoAreaCadastro() }}
          div
          validation-provider(:rules="isMa && (dadosImovel.areaOrigin && dadosImovel.areaOrigin !== 0) ? 'required' : ''" , v-slot="{ errors }")
            app-label( label="Tipo:" :required="false")
            el-select.input(
              class="select",
              v-model="dadosImovel.tipoArea",
              placeholder="Selecione",
              filterable,
              clearable,
              @clear="dadosImovel.tipoArea = null"
              value-key="id",
              name="Tipo",
              :disabled="isMa ? (!dadosImovel.areaOrigin || dadosImovel.areaOrigin === 0) : false"
            )
              el-option(
                v-for="item in tiposArea",
                :key="item.id",
                :label="item.nome",
                :value="item.codigo"
              )
            span.help.erro {{ errors[0] }}
    el-row.marginBotton(type='flex', :gutter="30" v-if="isOnerosoNaoOneroso")
      el-col(:span="8")
          app-label(label="Matrícula:" :required="false")
          el-input.input(
            v-model="dadosImovel.matricula"
            name="Matrícula"
          )
      el-col(:span="8")
          app-label(label="Livro:" :required="false")
          el-input.input(
            v-model="dadosImovel.livro"
            name="Livro"
          )
      el-col(:span="8")
          app-label(label="Folha:" :required="false")
          el-input.input(
            v-model="dadosImovel.folha"
            name="Folha"
          )
    el-row.marginBotton(type='flex', :gutter="30" v-if="isOnerosoNaoOneroso")
      el-col(:span="8")
          app-label(label="Cartório:" :required="false")
          el-input.input(
            v-model="dadosImovel.cartorio"
            name="Cartório"
          )
      el-col(:span="8")
          app-label(label="Município do Cartório:", :required="false")
          el-select.full-width.input(
            v-model='dadosImovel.municipioCartorio'
            filterable
          )
            el-option(
                v-for='municipio in municipios'
                :key='municipio.id',
                :label='municipio.nome'
                :value='municipio.id'
            )
      el-col(:span="8")
          app-label(label="Latitude:" :required="false")
          el-input.input(
            v-model="dadosImovel.latitude"
            name="Latitude"
            v-mask="[`##°##'##,###\"A`]"
          )
    el-row.marginBotton(type='flex', :gutter="30" v-if="isOnerosoNaoOneroso")
      el-col(:span="8")
          app-label(label="Longitude:" :required="false")
          el-input.input(
            v-model="dadosImovel.longitude"
            name="Longitude"
            v-mask="[`##°##'##,###\"A`]"
          )
  </template>

<script>
import AppDisplay from '@/components/AppDisplay'
import AppDownloadArquivo from '@/components/AppDownloadArquivo'
import { mapActions } from 'vuex'
import AppLabel from '@/components/AppLabel'
import AppDoubleInput from '@/components/AppDoubleInput'
import onlyInputNumbers from '@/components/mixins/OnlyInputNumber'
import { conversaoAreaTexto } from '@/utils/utils'
const { tiposArea } = require('@/utils/' +
  process.env.ESTADO +
  '/regrasCentral').default

export default {
  mixins: [onlyInputNumbers],
  components: {
    AppDisplay,
    AppDownloadArquivo,
    AppLabel,
    AppDoubleInput
  },

  props: {
    dadosImovel: {
      type: Object,
      required: true
    },
    municipios: {
      type: Array,
      required: true
    },
    isOnerosoNaoOneroso: {
      type: Boolean,
      required: false,
      default: false
    },
    isReurbIndividual: {
      type: Boolean,
      required: false,
      default: false
    },
    isMa: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  watch: {
    'dadosImovel.areaOrigin' (newValue) {
      // Limpa o campo `tipoArea` quando `areaOrigin` é nula ou igual a 0
      if (!newValue || newValue === '0') {
        this.dadosImovel.tipoArea = null
      }
    }
  },
  methods: {
    ...mapActions({
      findMunicipiosByEstadoAtual: 'municipios/findMunicipiosByEstadoAtualPromise'
    }),
    conversaoAreaCadastro () {
      return conversaoAreaTexto(this.dadosImovel.areaOrigin, this.dadosImovel.tipoArea)
    }
  },

  data () {
    return {
      tiposArea: tiposArea
    }
  }
}
</script>
<style lang="scss">
.label {
  font-weight: bold;
}

.marginBotton {
  margin-bottom: 20px;
}

.space {
  padding-bottom: 20px;
}

.full-width {
  width: 100%;
}

.conversao {
  margin-top: 5px;
  font-size: 13px;
}

.inputArea {
  display: flex;
  flex-direction: row;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/components/AppFormularioAnaliseDadosImovel.vue